import React, { PropsWithChildren } from 'react';
import { ModuleTopBar, Box, Flex, Grid } from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import FlowProductsBottomBar from '@flows/src/components/flow-products/FlowProductsBottomBar';
import FlowProductsAnvaSidebar from '@flows/src/components/flow-products/FlowProductsAnvaSidebar';

const FlowProductsLayout: React.FC<PropsWithChildren> = ({ children }) => {
  const { t } = useTranslation();

  const getBackText = () => {
    return t('BACK-TO-DASHBOARD');
  };
  const getPreviousUrl = () => {
    return '/dashboard';
  };

  return (
    <Grid
      templateColumns={{ base: 'auto 1fr' }}
      w="100%"
      h="100%"
      position="relative"
    >
      <FlowProductsAnvaSidebar />
      <Grid
        templateRows="auto 1fr auto"
        position="relative"
        overflow-y="auto"
        flexGrow="1"
      >
        <Box position="sticky" top="0" bg="white" zIndex="1">
          <ModuleTopBar
            backRef={getPreviousUrl()}
            title={t('CONVERSATIONS_REPORT-CREATION_PRODUCT-SELECTION')}
            backText={getBackText()}
          />
        </Box>
        <Flex flexDirection="column" w="100%" align="center" flexGrow="1">
          {children}
        </Flex>
        <FlowProductsBottomBar
          previousUrl={getPreviousUrl()}
          backText={getBackText()}
        />
      </Grid>
    </Grid>
  );
};

export default FlowProductsLayout;
